import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px;
`;
